















import { defineComponent } from "@vue/composition-api";
import { VaultCategory } from "@scrile/api-provider/dist/api/VaultsProvider";
import BaseThumbnailButton from "@/components/BaseThumbnailButton";
import VaultCategoryItem from "../VaultCategoryItem";

export default defineComponent({
  name: "VaultCategoryList",
  components: { VaultCategoryItem, BaseThumbnailButton },
  props: {
    allowAi: { type: Boolean, default: false },
    items: { type: Array as () => VaultCategory[], default: [] },
    checkedCategoryId: { type: String },
  },
});
